import {createHelpers, getField, updateField} from "vuex-map-fields";

const {getBrandComponentListField, updateBrandComponentListField} = createHelpers({
    getterType: 'getBrandComponentListField',
    mutationType: 'updateBrandComponentListField',
});
const {getBrandComponentSearchField, updateBrandComponentSearchField} = createHelpers({
    getterType: 'getBrandComponentSearchField',
    mutationType: 'updateBrandComponentSearchField',
});

export default {
    state: {
        componentList: [],
        componentCategoryList: [],
        componentSubCategoryList: [],
        options: {
            page: 1,
            itemsPerPage: 50,
            sortBy: ['mpn'],
            sortDesc: [false],
            multiSort: false,
            mustSort: true,
            descending: false,

        },
        totalRecords: 0,
        loading: false,
        columns: [
            {text: 'MPN', value: 'mpn', sortable: true, filterable: true},
            {text: 'Description', value: 'description', sortable: true,},
            {text: 'Category', value: 'subcategory__category__category', sortable: true,},
            {text: 'Subcategory', value: 'subcategory__subcategory', sortable: true,},
        ],
        brandComponentParameters: [],
        brandComponentCategorySearchId: null,
        brandComponentParametersLoading: false,
        brandComponentSearchTerm: null,
    },

    actions: {
        async fetchComponentList(ctx) {
            ctx.commit('updateLoading', true)
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const page = ctx.state.options.page
            const page_size = ctx.state.options.itemsPerPage
            let order_by = ctx.state.options.sortBy[0]
            if (ctx.state.options.sortDesc[0] == true) {
                order_by = '-' + order_by
            }
            let url = "/api/component/?page=" + page + "&page_size=" + page_size + "&order_by=" + order_by
            if (ctx.state.brandComponentCategorySearchId != null) {
                url += '&category_id=' + ctx.state.brandComponentCategorySearchId
            }

            if (ctx.state.brandComponentCategorySearchId != null) {
                for (let brandComponentParameter of ctx.state.brandComponentParameters) {
                    if (brandComponentParameter.hasOwnProperty('value')) {
                        console.log(brandComponentParameter)
                        if ((Array.isArray(brandComponentParameter.value) && brandComponentParameter.value.length != 0) ||
                            (Array.isArray(brandComponentParameter.value) !== true && brandComponentParameter.value != null))
                            url += '&' + brandComponentParameter.parameter + '__' + brandComponentParameter.match + '=' +
                                brandComponentParameter.value
                    }
                }
            }
            if (ctx.state.brandComponentSearchTerm != null) {
                url += '&search_term=' + ctx.state.brandComponentSearchTerm
            }
            let res = await fetch(url, requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                ctx.commit('updateLoading', false)
                return
            }
            const resJson = await res.json();
            const totalRecords = resJson.count
            const componentList = resJson.results

            ctx.commit('updateComponentList', componentList)
            ctx.commit('updateTotalRecords', totalRecords)
            ctx.commit('updateLoading', false)
        },

        async fetchCategoryList(ctx) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/component_category/", requestParams);
            const resCategory = await res.json();
            ctx.commit('updateCategory', resCategory)
        },

        async fetchSubCategoryList(ctx) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/component_subcategory/", requestParams);
            const resSubCategory = await res.json();
            ctx.commit('updateSubCategory', resSubCategory)
        },

        async fetchBrandComponentCategoryParameters(ctx) {
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            let url = "/api/component_category_parameters/?is_searchable=True"
            if (ctx.state.brandComponentCategorySearchId != null) {
                url += '&category=' + ctx.state.brandComponentCategorySearchId
            }
            let res = await fetch(url, requestParams);
            if (!res.ok) {
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
                ctx.commit('updateBrandComponentParametersLoading', false)
                return
            }
            const brandComponentParameters = await res.json();
            ctx.commit('updateBrandComponentParameters', brandComponentParameters.results)
            ctx.commit('updateBrandComponentParametersLoading', false)
        },
    },

    mutations: {
        updateBrandComponentListField,
        updateBrandComponentSearchField,
        updateComponentList(state, componentList) {
            state.componentList = componentList
        },
        updateTotalRecords(state, totalRecords) {
            state.totalRecords = totalRecords
        },
        updateCategory(state, categoryDictList) {
            let componentCategoryList = []
            for (let category of categoryDictList) {
                const componentCategory = {
                    text: category.category,
                    value: category.id,
                }
                componentCategoryList.push(componentCategory)
            }
            state.componentCategoryList = componentCategoryList
        },
        updateSubCategory(state, subCategoryDictList) {
            let componentSubCategoryList = []
            for (let category of subCategoryDictList) {
                const componentCategory = {
                    text: category.subcategory,
                    value: category.id,
                }
                componentSubCategoryList.push(componentCategory)
            }
            state.componentSubCategoryList = componentSubCategoryList
        },
        updateLoading(state, loading) {
            state.loading = loading
        },
        updateBrandComponentParameters(state, brandComponentParameters) {
            state.brandComponentParameters = brandComponentParameters
        },
        updateBrandComponentParametersLoading(state, brandComponentParametersLoading) {
            state.brandComponentParametersLoading = brandComponentParametersLoading
        },
        updateBrandComponentCategorySearchId(state, brandComponentCategorySearchId) {
            state.brandComponentCategorySearchId = brandComponentCategorySearchId
        },
        updateBrandComponentSearchTerm(state, brandComponentSearchTerm) {
            state.brandComponentSearchTerm = brandComponentSearchTerm
        },
    },

    getters: {
        getBrandComponentListField,
        getBrandComponentSearchField,
        getComponentList(state) {
            return state.componentList
        },
        getColumns(state) {
            return state.columns
        },
        getCategories(state) {
            return state.componentCategoryList
        },
        getSubCategories(state) {
            return state.componentSubCategoryList
        },
        getBrandComponentParameters(state) {
            return state.brandComponentParameters
        },
    }
}